import { Directive,HostListener,Input, ViewContainerRef } from '@angular/core';


@Directive({
  selector: '[containtDirective]'
})
export class ContaintDirective {

 
  constructor( public viewContainerRef : ViewContainerRef) { 
      
  }

}